import { render, staticRenderFns } from "./CardTitleBar.vue?vue&type=template&id=8b476b48"
import script from "./CardTitleBar.vue?vue&type=script&lang=js"
export * from "./CardTitleBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports